export default {
      id: "ic_author_rectangle-usage",
      viewBox: "0 0 62 67",
      url: "/" + "images/icons.3.109.2.svg#ic_author_rectangle-usage",
      toString: function () {
        return this.url;
      }
    }